import React from "react";

const defaultOgImage = "https://vmnk.gumlet.io/get-quote-imageone.svg";

function publicSiteOrigin() {
  const host = process.env.REACT_APP_PUBLIC_HOST;
  if (host && !host.includes("localhost")) {
    return host.replace(/\/$/, "");
  }
  return "https://weddingpe.com";
}

/** Same shape as Next.js `next/head` children — applied via `SyncNextStyleHead`. */
export function getGetQuotePageHeader() {
  const site = publicSiteOrigin();
  return (
    <>
      <title>WeddingPe — Find &amp; book venues for your event</title>
      <meta
        property="og:description"
        content="WeddingPe helps you find and book venues and banquets for weddings and events."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${site}/get-quote`} />
      <meta property="og:imagez" content={defaultOgImage} />
      <meta property="og:site_name" content="WeddingPe" />
      <meta
        name="description"
        content="WeddingPe helps you find and book venues and banquets for weddings and events."
      />
    </>
  );
}

const corporateDelhiNcrPath = "/perfect-corporate-event-venues-in-delhi-ncr";

export function getCorporateLandingGetQuotePageHeader() {
  const site = publicSiteOrigin();
  const desc =
    "Find and book corporate event venues in Delhi NCR. Simplified venue booking and event planning for your business events.";
  return (
    <>
      <title>WeddingPe — Corporate event venues in Delhi NCR</title>
      <meta property="og:description" content={desc} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`${site}${corporateDelhiNcrPath}`} />
      <meta property="og:image" content={defaultOgImage} />
      <meta property="og:site_name" content="WeddingPe" />
      <meta name="description" content={desc} />
    </>
  );
}
